import { NextSeo } from 'next-seo'

import { STOREFRONT_NAME } from '@/shared/consts'

export function HomePageSeo() {
  const seoTitle = `${STOREFRONT_NAME} - Personalised Storybooks Starring Your Child`

  const seoDescription =
    'Personalised storybooks starring your child. Pick a hand-crafted story, add your child\'s look, and watch them become the hero on every page. Or create an entirely original adventure of your own. Premium hardcover, delivered to your door.'

  return (
    <NextSeo
      title={seoTitle}
      description={seoDescription}
      openGraph={{
        type: 'website',
        url: 'https://www.pixieworldstore.com/',
        title: seoTitle,
        description: seoDescription,
        images: [
          {
            url: 'https://www.pixieworldstore.com/static/og-image.png',
            width: 1200,
            height: 630,
            alt: 'PixieWorld - Personalised Storybooks',
          },
          {
            url: 'https://www.pixieworldstore.com/static/og-image-square-small.png',
            width: 256,
            height: 256,
            alt: 'PixieWorld - Personalised Storybooks',
            type: 'image/png',
          },
        ],
        site_name: STOREFRONT_NAME,
      }}
      twitter={{
        handle: '@pixieworldau',
        site: '@pixieworldau',
        cardType: 'summary_large_image',
      }}
      additionalMetaTags={[
        {
          name: 'keywords',
          content: 'AI personalised storybooks, AI children\'s books, AI-powered storybooks, personalised storybooks, custom children books, kids books, personalised gifts, children stories, PixieWorld, AI book creator, watercolor illustrated books, custom storybook creator, create your own storybook',
        },
        {
          property: 'reddit-title',
          content: seoTitle,
        },
        {
          property: 'fb:app_id',
          content: '1225442005624528',
        },
      ]}
      additionalLinkTags={[
        {
          rel: 'icon',
          href: '/favicon/favicon.ico',
        },
        {
          rel: 'apple-touch-icon',
          href: '/favicon/apple-touch-icon.png',
          sizes: '180x180',
        },
        {
          rel: 'manifest',
          href: '/favicon/site.webmanifest.json',
        },
      ]}
    />
  )
}